import "core-js/modules/es6.array.fill";
import _slicedToArray from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { defOp } from "./internal/codegen";
import { SET_N } from "./internal/templates";

var _defOp = defOp(SET_N, "a,n", "a", "a", 0, ""),
    _defOp2 = _slicedToArray(_defOp, 4),
    setN = _defOp2[0],
    setN2 = _defOp2[1],
    setN3 = _defOp2[2],
    setN4 = _defOp2[3];

export { setN, setN2, setN3, setN4 };
export var zero = function zero(a) {
  return setN(a, 0);
};
export var one = function one(a) {
  return setN(a, 1);
};
export var zeroes = function zeroes(n) {
  return new Array(n).fill(0);
};
export var ones = function ones(n) {
  return new Array(n).fill(1);
};